"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HybridListStateReducerActions = exports.AlphaListStateReducerActions = exports.ListStateReducerActions = exports.JIL_ACCEPT_HEADER = exports.JIL_HEADERS = exports.MODEL_LIST_CONSTANTS = exports.SortOrder = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

const react_data_source_jil_1 = require("@pandora/react-data-source-jil");

Object.defineProperty(exports, "SortOrder", {
  enumerable: true,
  get: function () {
    return react_data_source_jil_1.JilSortOrder;
  }
});
var MODEL_LIST_CONSTANTS;

(function (MODEL_LIST_CONSTANTS) {
  MODEL_LIST_CONSTANTS["ASC"] = "ASC";
  MODEL_LIST_CONSTANTS["DESC"] = "DESC";
  MODEL_LIST_CONSTANTS[MODEL_LIST_CONSTANTS["LIST_DEFAULT_PAGE_SIZE"] = 20] = "LIST_DEFAULT_PAGE_SIZE";
  MODEL_LIST_CONSTANTS[MODEL_LIST_CONSTANTS["SEARCH_QUERY_MIN_LENGTH"] = 3] = "SEARCH_QUERY_MIN_LENGTH";
})(MODEL_LIST_CONSTANTS = exports.MODEL_LIST_CONSTANTS || (exports.MODEL_LIST_CONSTANTS = {}));
/** The headers for a Jil response */


var JIL_HEADERS;

(function (JIL_HEADERS) {
  JIL_HEADERS["CONTENT_TYPE"] = "content-type";
  JIL_HEADERS["CURRENT_PAGE"] = "x-current-page";
  JIL_HEADERS["NEXT_PAGE"] = "x-next-page";
  JIL_HEADERS["PAGE_COUNT"] = "x-page-count";
  JIL_HEADERS["PAGE_SIZE"] = "x-page-size";
  JIL_HEADERS["REQUEST_ID"] = "x-request-id";
  JIL_HEADERS["TOTAL_COUNT"] = "x-total-count";
})(JIL_HEADERS = exports.JIL_HEADERS || (exports.JIL_HEADERS = {}));
/** The values for the Accept header */


var JIL_ACCEPT_HEADER;

(function (JIL_ACCEPT_HEADER) {
  JIL_ACCEPT_HEADER["DEFAULT"] = "application/json";
  JIL_ACCEPT_HEADER["V2"] = "application/vnd.com.adobe.jil.storage.paging.v2+json";
})(JIL_ACCEPT_HEADER = exports.JIL_ACCEPT_HEADER || (exports.JIL_ACCEPT_HEADER = {}));

var ListStateReducerActions;

(function (ListStateReducerActions) {
  ListStateReducerActions["setFilterQuery"] = "setFilterQuery";
  ListStateReducerActions["setPageNumber"] = "setPageNumber";
  ListStateReducerActions["setPageSize"] = "setPageSize";
  ListStateReducerActions["setSortKeyAndReverseIfSameKey"] = "setSortKeyAndReverseIfSameKey";
})(ListStateReducerActions = exports.ListStateReducerActions || (exports.ListStateReducerActions = {}));

var AlphaListStateReducerActions;

(function (AlphaListStateReducerActions) {
  AlphaListStateReducerActions["goToNextPage"] = "goToNextPage";
  AlphaListStateReducerActions["goToPreviousPage"] = "goToPreviousPage";
  AlphaListStateReducerActions["reset"] = "reset";
  AlphaListStateReducerActions["setPageSize"] = "setPageSize";
  AlphaListStateReducerActions["setResponseAndHeaders"] = "setResponseAndHeaders";
  AlphaListStateReducerActions["setSortKeyAndReverseIfSameKey"] = "setSortKeyAndReverseIfSameKey";
  AlphaListStateReducerActions["shouldRefreshOnSearch"] = "shouldRefreshOnSearch";
})(AlphaListStateReducerActions = exports.AlphaListStateReducerActions || (exports.AlphaListStateReducerActions = {}));

var HybridListStateReducerActions;

(function (HybridListStateReducerActions) {
  HybridListStateReducerActions["goToNextPage"] = "goToNextPage";
  HybridListStateReducerActions["goToPreviousPage"] = "goToPreviousPage";
  HybridListStateReducerActions["setPage"] = "setPage";
  HybridListStateReducerActions["setResponseAndHeaders"] = "setResponseAndHeaders";
})(HybridListStateReducerActions = exports.HybridListStateReducerActions || (exports.HybridListStateReducerActions = {}));